import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {Button, Dialog, DialogTitle, DialogActions, Paper, FormControl, InputLabel, OutlinedInput} from "@mui/material"
import { getPWRequest } from "../actions/viewinstance";
import { Link as RouterLink } from "react-router-dom";
import  PwdService from "../services/pwd.service"
import '../styles/reset.css'

const PasswordRequest = (props) => {
  const [callVI, setCallVI] = useState(false)
  const [searchParams] = useSearchParams();
  const { viewInstance, settings } = useSelector(state => state.viewinstance)
  const [username, setUsername] = useState('')
  const [open, setOpen] = useState(false)
  const globcon = useSelector((state) => state.contexts.entities)

  const dispatch = useDispatch()

  useEffect(() => {
    if((!viewInstance || !viewInstance.PwdResetRequestPage) && !callVI){
      setCallVI(true)
      dispatch(getPWRequest(searchParams.get("g"), globcon.LanguageId || -1))
    }
  },[window.location.pathname])

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  }; 

  const handleSubmit = (e) => {
    setOpen(true)
    PwdService.requestPassword(searchParams.get("g"),username, 'PASSOWRD_RESET_EMAIL')
    
  }

  return (
    <Paper elevation={16}>
      <div class="container base">
      {viewInstance && viewInstance.PwdResetRequestPage && (
        <div>
          <h3>{viewInstance.PwdResetRequestPage.PwdResetRequestTitle}</h3>
          <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" style={{width:'100%'}}>
          <InputLabel htmlFor="outlined-adornment">{viewInstance.PwdResetRequestPage.PwdResetRequestUsernameInputBoxFrame.PwdResetRequestUsernamePrompt}</InputLabel>
          <OutlinedInput
            id="outlined-adornment"
            value={username} 
            onChange={onChangeUsername}
          />
        </FormControl>
          <div>
            <Button onClick={() => handleSubmit()} variant="contained" size="large" style={{width: '100%'}}>{viewInstance.PwdResetRequestPage.PwdResetRequestSubmitButton}</Button>
            </div>     

          <Dialog open={open}>
            <DialogTitle>{viewInstance.PwdResetRequestPage.PwdResetRequestPopupMsgAfterSubmit}</DialogTitle>
            <DialogActions>
              <RouterLink to={'/login?g=' + localStorage.getItem('group')} >
                <Button>
                    {viewInstance.PwdResetRequestPage.BackToLoginLabel}
                </Button>
              </RouterLink>
            </DialogActions> 
          </Dialog>   
          </div>

      )}  
      </div>
      
    </Paper>
  );
};

export default PasswordRequest;

/*

{viewInstance.length && viewInstance.PwdResetRequestPage.length && (
        <h3>
        {viewInstance.PwdResetRequestPage.PwdResetRequestTitle}
        </h3>
        <TextField label={viewInstance.PwdResetRequestPage.PwdResetRequestUsernameInputBoxFrame.PwdResetRequestUsernamePrompt}></TextField>
        <Button onClick={() => handleSubmit}>{viewInstance.PwdResetRequestPage.PwdResetRequestSubmitButton}</Button>

        )

        }
{
    "PwdResetRequestTitle": "Reset Your Password",
    "PwdResetRequestSubmitButton": "Submit",
    "PwdResetRequestUsernameInputBoxFrame": {
        "PwdResetRequestUsernameLabel": "",
        "PwdResetRequestUsernamePrompt": "Username",
        "PwdResetRequestUsernameValue": ""
    },
    "PwdResetRequestPopupMsgAfterSubmit": "Your request has been sent. Please check your email for further instructions.",
    "PwdResetRequestPopupMsgForEmailError": "There was a problem sending your email. Please contact your administrator.",
    "PwdResetRequestPopupMsgInvalidSpecialChar": "Sorry, the {SpecialChar} character is not allowed in usernames.",
    "PwdResetRequestPopupMsgInvalidUsername": "Username not found",
    "PwdResetRequestPopupMsgNoEmailAddress": "Email address not found",
    "PageHead": {
        "FirstName": "<<FIRST NAME>>",
        "LastName": "<<LAST NAME>>",
        "FlipCardMsg": "Click to learn more",
        "HomeLinkText": "Home",
        "HomeLinkImage": "",
        "PrintButtonText": "",
        "PrintButtonImage": ""
    },
    "BackToLoginLabel": "Back To Login"
} */